import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip/Tooltip';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  field: string;
  id: number;
  isTooltipShown: boolean;
  isEditable: boolean;
  onClickEditableCell: () => void;
  renderHint?: (btn: JSX.Element) => JSX.Element | null;
}

export function DocumentTableCell({
  field,
  id,
  isTooltipShown,
  isEditable,
  onClickEditableCell,
  renderHint,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation();
  const tooltipContent = (
    <div className='text-center'>
      <p>{t("You can't edit this invoice")}</p>
      <p>{t('Data for this period is confirmed')},</p>
      <p>{t('and the report is being prepared or completed')}</p>
    </div>
  );

  const content = (
    <span className='px-2 py-1' data-testid={`cell-${field}-${id}`}>
      {children}
    </span>
  );
  const btn = (
    <Button
      styling='outline'
      onClick={onClickEditableCell}
      className='min-h-[32px] min-w-[60px] !bg-[#FFFFFF70] !px-2 !py-0 text-end !font-normal'
      data-testid={`editable-button-${field}-${id}`}
    >
      {children}
    </Button>
  );

  return isTooltipShown ? (
    <Tooltip content={tooltipContent}>{content}</Tooltip>
  ) : isEditable ? (
    renderHint ? (
      renderHint(btn)
    ) : (
      btn
    )
  ) : (
    content
  );
}
